(function () {
  function toast(msg) {
    var t = document.createElement('div'); t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:92px;transform:translateX(-50%);z-index:100;padding:13px 20px;border-radius:18px;color:#F0ECDE;font-size:13px;background:rgba(59,44,39,.86);-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);white-space:nowrap';
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 2400);
  }
  function init(root) {
    var main = root.querySelector('.fio-pdp__img');
    root.querySelectorAll('[data-pdp-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-pdp-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        if (main) { main.srcset = b.dataset.srcset; main.src = b.dataset.src; }
      });
    });
    var btn = root.querySelector('[data-pdp-add]'), priceEl = root.querySelector('[data-pdp-price]'), ctaPrice = root.querySelector('[data-pdp-cta-price]');
    root.querySelectorAll('[data-pdp-size]').forEach(function (s) {
      s.addEventListener('click', function () {
        if (s.disabled) return;
        root.querySelectorAll('[data-pdp-size]').forEach(function (x) { x.classList.toggle('is-sel', x === s); });
        btn.dataset.variant = s.dataset.pdpSize;
        if (priceEl) priceEl.textContent = s.dataset.price;
        if (ctaPrice) ctaPrice.textContent = s.dataset.price;
        var u = new URL(window.location.href); u.searchParams.set('variant', s.dataset.pdpSize); history.replaceState(null, '', u.toString());
      });
    });
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (btn.disabled || btn.classList.contains('is-busy')) return;
      if (!btn.dataset.variant) {
        toast('Escolha um tamanho para continuar');
        var sz = root.querySelector('.fio-pdp__sizes'); if (sz && sz.animate) sz.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 });
        return;
      }
      btn.classList.add('is-busy');
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: [{ id: +btn.dataset.variant, quantity: 1 }] };
      if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (data) {
          btn.classList.remove('is-busy');
          if (drawer && data.sections && drawer.renderContents) {
            var item = data.items && data.items[0] ? data.items[0] : {}; item.sections = data.sections; drawer.renderContents(item);
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          } else { toast('Adicionado à sacola'); }
        })
        .catch(function (err) { btn.classList.remove('is-busy'); toast((err && err.description) || 'Não foi possível adicionar. Tente de novo.'); });
    });
  }
  function boot() {
    document.querySelectorAll('[data-fio-pdp]').forEach(init);
    var hasLook = !!document.getElementById('monte-seu-look');
    document.querySelectorAll('.fio-lb-link').forEach(function (l) { l.hidden = !hasLook; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
